import { render, staticRenderFns } from "./startDemo.vue?vue&type=template&id=29d9599b&"
import script from "./startDemo.vue?vue&type=script&lang=js&"
export * from "./startDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports